import { configureStore } from "@reduxjs/toolkit";
import { LoginUser } from "Data/interfaces";
import sessionMiddleware from "Data/middleware/sessionMiddleware";
import { baseApi } from "Data/services/baseApi";
import { getTypedSecureLocalStorage } from "Data/services/localStorageService";
import authReducer from "./Data/features/authSlice";


// Configure the store first before defining types
export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
  },
  // load from local storage
  preloadedState: loadFromLocalStorage(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, sessionMiddleware),
});


function loadFromLocalStorage() {
  try {
    const serialisedState: LoginUser | null = getTypedSecureLocalStorage<LoginUser>('authUser');
    if (serialisedState == null) return undefined;

    return {
      auth: {
        isLoggedIn: true,
        isSocketConnected: false,
        user: serialisedState
      }
    };
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}


// Define types **after** store is created
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
